import { jsx } from 'react/jsx-runtime';
import cx from 'clsx';
import dayjs from 'dayjs';
import { useState, useRef } from 'react';
import { u as useDocumentClick } from './hook-CbBbLTHu.js';
import { alignBottomXBegin } from '../utils/position/absolute/index.js';
import { alignBottomXBegin as alignBottomXBegin$1 } from '../utils/position/fixed/index.js';
import { A as AbsolutePositionAligner } from './component-Drqwk5-1.js';
import { F as FixedPositionAligner } from './component-gOY2cmyW.js';
import { I as IosArrowDown } from './component-DJBRQOIp.js';
import { I as Input } from './component-DchS1oBD.js';
import { I as InputGroup, b as INPUT_GROUP_VARIANT_EMPTY } from './component-BuW2PW1k.js';
import './component-PCp5abNO.js';
import './styles.module-C8v7Qt7u.js';
import { S as SELECT_ARROW_DOWN_ICON_SIZE } from './styles.module-dDsRFEAR.js';
import { C as Calendar } from './component-C0bJH0UU.js';
import { s as styleInject } from './style-inject.es-tgCJW-Cu.js';

const DATE_PICKER_INPUT_DATE_FORMAT = 'ddd, DD MMMM YYYY';
const DATE_PICKER_CALENDAR_LAYER_POSITION_ABSOLUTE = 'absolute';
const DATE_PICKER_CALENDAR_LAYER_POSITION_FIXED = 'fixed';

var css_248z = ".SGCM_UIKIT_REACT_DatePicker_containerDateInput_1xozt_1 {\n  cursor: pointer;\n}\n\n.SGCM_UIKIT_REACT_DatePicker_inputDatePicker_1xozt_5.SGCM_UIKIT_REACT_DatePicker_isInvalid_1xozt_5 {\n  color: #f0484e;\n}\n\n.SGCM_UIKIT_REACT_DatePicker_containerCalendar_1xozt_9 {\n  z-index: 1000;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGVBQWU7QUFDakI7O0FBRUE7RUFDRSxjQUFjO0FBQ2hCOztBQUVBO0VBQ0UsYUFBYTtBQUNmIiwiZmlsZSI6InN0eWxlcy5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXJEYXRlSW5wdXQge1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cbi5pbnB1dERhdGVQaWNrZXIuaXNJbnZhbGlkIHtcbiAgY29sb3I6ICNmMDQ4NGU7XG59XG5cbi5jb250YWluZXJDYWxlbmRhciB7XG4gIHotaW5kZXg6IDEwMDA7XG59Il19 */";
var styles = {"containerDateInput":"SGCM_UIKIT_REACT_DatePicker_containerDateInput_1xozt_1","inputDatePicker":"SGCM_UIKIT_REACT_DatePicker_inputDatePicker_1xozt_5","isInvalid":"SGCM_UIKIT_REACT_DatePicker_isInvalid_1xozt_5","containerCalendar":"SGCM_UIKIT_REACT_DatePicker_containerCalendar_1xozt_9"};
styleInject(css_248z);

const DatePicker = ({ calendarContainerClassName, calendarLayerPosition = DATE_PICKER_CALENDAR_LAYER_POSITION_ABSOLUTE, maxDate, maxYear, minDate, minYear, defaultYear, defaultMonth, value, inputClassName, isInvalid, placeholder, inputArrowContainerClassName, onChange, }) => {
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const containerRootElRef = useRef(null);
    const monthSelectElRef = useRef(null);
    const yearSelectElRef = useRef(null);
    const onDocClickRef = useRef(null);
    const valueDayjs = dayjs(value === '' ? undefined : value);
    const { [calendarLayerPosition]: { component: PositionAligner, rectCalculator: positionAlignerRectCalculator, }, } = {
        [DATE_PICKER_CALENDAR_LAYER_POSITION_ABSOLUTE]: {
            component: AbsolutePositionAligner,
            rectCalculator: alignBottomXBegin,
        },
        [DATE_PICKER_CALENDAR_LAYER_POSITION_FIXED]: {
            component: FixedPositionAligner,
            rectCalculator: alignBottomXBegin$1,
        },
    };
    const onCalendarOpen = () => {
        setIsCalendarOpen(true);
    };
    if (!onDocClickRef.current) {
        onDocClickRef.current = ({ target }) => {
            const isTargetContained = target instanceof Node
                && (containerRootElRef.current?.contains(target)
                    || monthSelectElRef.current?.contains(target)
                    || yearSelectElRef.current?.contains(target)
                    || !document.contains(target));
            if (isTargetContained) {
                return;
            }
            setIsCalendarOpen(false);
        };
    }
    useDocumentClick({
        onClickRef: onDocClickRef,
    });
    return (jsx(PositionAligner, { isActive: isCalendarOpen, rectCalculator: positionAlignerRectCalculator, targetElement: (jsx(Calendar, { defaultMonth: defaultMonth, defaultYear: defaultYear, maxDate: maxDate, maxYear: maxYear, minDate: minDate, minYear: minYear, monthSelectElRef: monthSelectElRef, value: valueDayjs.toDate(), yearSelectElRef: yearSelectElRef, onChange: onChange })), targetElementClassName: cx(styles.containerCalendar, calendarContainerClassName), children: jsx("div", { ref: containerRootElRef, "aria-label": "Open calendar of date picker", className: styles.containerDateInput, role: "button", tabIndex: 0, onClick: onCalendarOpen, onKeyDown: onCalendarOpen, children: jsx(InputGroup, { isInvalid: isInvalid, suffix: jsx(IosArrowDown, { size: SELECT_ARROW_DOWN_ICON_SIZE }), suffixContainerClassName: inputArrowContainerClassName, suffixVariant: INPUT_GROUP_VARIANT_EMPTY, children: jsx(Input, { className: cx(styles.inputDatePicker, {
                        [styles.isInvalid]: isInvalid,
                    }, inputClassName), isInvalid: isInvalid, value: value === ''
                        ? placeholder
                        : dayjs(value).format(DATE_PICKER_INPUT_DATE_FORMAT), isBorderless: true, readOnly: true }) }) }) }));
};

export { DatePicker as D, DATE_PICKER_CALENDAR_LAYER_POSITION_ABSOLUTE as a, DATE_PICKER_CALENDAR_LAYER_POSITION_FIXED as b };
//# sourceMappingURL=component-DPD164Wk.js.map
